import * as XLSX from "xlsx";

interface ISheet {
  name: string;
  header: string[];
  // data: any[][];
  data: unknown[];
}

export type DownloadableReport = {
  fileName: string;
  sheets: ISheet[];
};

type UseXLSXGeneratorReturn = (report: DownloadableReport) => void;

export function useXLSXGenerator(): UseXLSXGeneratorReturn {
  const generateXLSX = (report: DownloadableReport) => {
    console.log("Generating report for: ", report);
    const workbook = XLSX.utils.book_new();
    report.sheets.forEach((sheet) => {
      //   const ws = XLSX.utils.aoa_to_sheet(sheet.data, {
      //     // origin: -1,
      //   });
      const ws = XLSX.utils.json_to_sheet(sheet.data, {
        // origin: -1,
      });
      XLSX.utils.book_append_sheet(workbook, ws, sheet.name);
    });
    const day = new Date();
    XLSX.writeFile(
      workbook,
      `${report.fileName} - ${
        day.getMonth() + 1
      }-${day.getDate()}-${day.getFullYear()}.xlsx`
    );
  };

  return generateXLSX;
}
